import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import PropTypes from 'prop-types'

import { Icon } from '@vfgroup-oneplatform/foundation/Components'
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../VfText'

import styles from './PaymentOption.Styles'

function PaymentOption({
  onPress,
  name,
  icon,
  theme,
}) {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={styles.container(theme)}
      disabled={!onPress}
    >
      <View style={styles.title}>
        <VfText
          i18nKey={name}
          weight="bold"
          color={theme.colors.textColor}
        />
      </View>
      <Icon
        name={icon}
        type="image"
        size={72}
        style={styles.icon}
      />
    </TouchableOpacity>
  )
}

PaymentOption.defaultProps = {
  theme: {
    name: 'light',
    colors: LightThemeColors
  },
}

PaymentOption.propTypes = {
  onPress: PropTypes.func,
  name: PropTypes.string,
  icon: PropTypes.any,
  theme: PropTypes.object,
}

export default PaymentOption
